export default __webpack_public_path__ + "static/media/currentstep.fe8cb372.svg";